import { CommonModule } from '@angular/common';
import { FilterPanelComponent } from './filter-panel.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/@dva/shared/material-components.module';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule, NgSelectModule],
  declarations: [FilterPanelComponent],
  exports: [FilterPanelComponent],
})
export class FilterPanelModule {}
